import React, { Component } from 'react';
import { getJsonItemInvariantCase } from '../Utilities/JsonFunctions.js'

declare var $;
declare var globalSns;

class NamezzzLanguageValue extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
    }

    onChange(e, data) {
        this.props.onChange(e, data);
    }

    onKeyPress(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            
            if (this.props.onEnter == null) {
                return;
            }
            this.props.onEnter(e);
        }
    }

    componentDidMount() {
        var url = globalSns.webApiUrl +"/api/useractions/languages?seqlang=" + this.props.seqlang;
        var _this = this;

        this.$el = $(this.el);
        this.$el.autocomplete({
            source: [
                 {
                     url: url,
                     type: 'remote',
                     ajax: {
                         dataType: 'json'
                     }
                 }
            ],
            valueKey: 'value',
            titleKey: 'value',
            showHint: false,
            visibleLimit: 10,
            limit: 10000,            
            autoselect: true
        }).on("autocompleted.xdsoft", function(e, data) {
            _this.onChange(e, data.key);
        }).on('blur', function(e) {
            var item = getJsonItemInvariantCase($(this).autocomplete("getSource")[0].xhr.responseJSON, "value", e.target.value);
            if (item != null)
                _this.onChange(e, item.key)
        })
    }

    componentWillUnmount() {
        this.$el.autocomplete('destroy');
    } 

    render() {
        return (
            <div className="EditingFormValueCell td">
                <input type="text" id={this.props.id} ref={el => this.el = el} maxLength="200" className="form-control" onChange={this.onChange} onKeyPress={this.onKeyPress} value={this.props.value} />
            </div>
        );
    }
}

export default NamezzzLanguageValue;


// WEBPACK FOOTER //
// ./src/Fields/NamezzzLanguageValue.js